import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  onRenderColumnStack: {
    height: 25,
  },
}));
